import { Avatar, Divider, Grid, Paper, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { DrawerWidget, LoadingWidget } from '../../../widgets';
import { getFilesArchivos } from '../../archivos/HelpersArchivos';
import FormEquiposJuegos from '../equipos_juegos/components/FormEquiposJuegos';
import { allJuegosAction } from '../juegos/JuegosAction';
import { PARAMS_JUEGOS } from '../juegos/JuegosReducer';
import { allRondasAction } from '../rondas/RondasAction';
import { setActivoTorneosAction } from '../torneos/TorneosAction';
import SelectFieldTorneosComponent from '../torneos/components/SelectFieldTorneos';
import GraficoResultadosComponent from '../torneos/panel/components/GraficoResultados';

const ResultadosView = () => {
  const dispatch = Redux.useDispatch();

  const rondasStore = Redux.useSelector((state) => state.rondas);
  const juegosStore = Redux.useSelector((state) => state.juegos);
  const torneosStore = Redux.useSelector((state) => state.torneos);
  const equiposJuegosStore = Redux.useSelector((state) => state.equiposJuegos);

  const [openForm, setOpenForm] = React.useState(false);

  async function getData(idTorneo) {
    const torneo = torneosStore.all.find((item) => item.id === idTorneo);
    setActivoTorneosAction(dispatch, torneo);
    const payload = {
      ...juegosStore.params,
      idTorneo,
    };
    dispatch({ type: PARAMS_JUEGOS, payload });
    await allRondasAction(dispatch, payload);
    await allJuegosAction(dispatch, payload);
  }

  React.useEffect(() => {
    if (torneosStore.all.length === 1) {
      getData(torneosStore.all[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [torneosStore.all]);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={rondasStore.loadingAll || juegosStore.loadingAll}
        />
        <Paper elevation={4} sx={{ p: 1 }}>
          <Grid container spacing={1}>
            <Grid item md={4}>
              <SelectFieldTorneosComponent
                isAll={false}
                value={juegosStore.params.idTorneo}
                onChange={(idTorneo) => getData(idTorneo)}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <DrawerWidget open={openForm} onClose={(val) => setOpenForm(val)}>
        <Typography variant="h6" color="initial" textAlign="center">
          Detalles de equipo
        </Typography>
        <br />
        <center>
          <Avatar
            alt={equiposJuegosStore.activo?.equipo.imagen.nombre}
            sx={{ width: 150, height: 150 }}
            src={getFilesArchivos(equiposJuegosStore.activo?.equipo.imagen)}
          />
        </center>
        <Typography
          variant="h5"
          color="initial"
          sx={{ fontWeight: 'bold' }}
          textAlign="center"
        >
          {equiposJuegosStore.activo?.equipo.nombre}
        </Typography>
        <br />
        <FormEquiposJuegos setOpenModalForm={setOpenForm} />
      </DrawerWidget>
      <Grid item md={12}>
        {juegosStore.all.length > 0 ? (
          <Paper elevation={4} sx={{ pt: 2 }}>
            <Typography variant="h6" color="initial" sx={{ pl: 2 }}>
              TABLERO
            </Typography>
            <Divider />
            <GraficoResultadosComponent
              isAdd={false}
              setOpenForm={setOpenForm}
            />
          </Paper>
        ) : (
          <Typography variant="h6" color="initial">
            No hay registro de juegos
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default ResultadosView;
